import moment from "moment";
import { axios } from "../../../lib/axios";

export const updateAppointmentRequest = (payload) => {
    return axios.put("appointment", { ...payload, isFromWeb: true })
};

export function getSignature({ topic, role, password }) {
    return axios.post(`session/create`, { topic, role: `${role}`, password })
}

export const getAppointments = ({ practitionerId, status }) => {
    return axios.get(`appointment?practitionerId=${practitionerId}&status=${status}`);
};
export const createEncounter = ({ patient, practitioner, appointmentId, appointmentTime, orgId, orgName }) => {
    const payload = {
        subject: patient,
        status: "in-progress",
        period: {
            start: appointmentTime
        },
        participant: [
            {
                individual: practitioner,
                period: {
                    start: moment().utc().format()
                }
            }
        ],
        type: "appointment",
        appointmentId,
        serviceProvider: {
            reference: `Organization/${orgId}`,
            display: orgName,
            type: "Organization"
        }
    }
    return axios.post("encounter", payload)
}

export const createEncounterInbound = ({ patient, status, practitionerId, practitionerName, proceedWith, orgId, questionnairInfo, requestedPeriod, orgName }) => {
    const payload = {
        "subject": patient,
        serviceProvider: {
            type: "Organization",
            reference: `Organization/${orgId}`,
            display: orgName
        },
        "practitionerId": practitionerId,
        "participant": [
            {
                "individual": {
                    "reference": `Practitioner/${practitionerId}`,
                    "type": "Practitioner",
                    "display": practitionerName
                }
            }
        ],
        "period": requestedPeriod,
        "type": [
            {
                "coding": [
                    {
                        "code": "VV",
                        "display": "Virtual Visit Encounter Type"
                    }
                ]
            }
        ],
        "questionnaireResponse": questionnairInfo,
        "proceedWith": proceedWith,
        "status": status
    }
    return axios.post("encounter", payload)
}

export const editEncounter = ({ encounterId, status, patient, practitionerId, practitionerName, proceedWith, orgId, questionnairInfo, requestedPeriod, orgName }) => {
    const payload = {
        "subject": patient,
        "serviceProvider": {
            "reference": `Organization/${orgId}`,
            "type": "Organization",
            display: orgName
        },
        "practitionerId": practitionerId,
        "participant": [
            {
                "individual": {
                    "reference": `Practitioner/${practitionerId}`,
                    "type": "Practitioner",
                    "display": practitionerName
                }
            }
        ],
        "requestedPeriod": requestedPeriod,
        "type": [
            {
                "coding": [
                    {
                        "code": "VV",
                        "display": "Virtual Visit Encounter Type"
                    }
                ]
            }
        ],
        "questionnaireResponse": questionnairInfo,
        "proceedWith": proceedWith,
        "status": status
    }
    return axios.put(`encounter/${encounterId}`, payload)
}

export const bookAppointment = ({ practitionerId, patientId, requestedPeriod, description, comment, sessionToken, isReschedule = false, document = null, intakeQuestions }) => {
    const payload = {
        requestType: practitionerId ? "provider" : "organization",
        status: "proposed",
        description,
        practitionerId,
        comment,
        patientId,
        requestedPeriod,
        document,
        isFromWeb: true,
        sessionToken,
        isReschedule,
        intakeQuestions
    }
    return axios.post("appointment", payload)
}
export const checkShedule = ({ actorId, date }) => {
    return axios.get(`schedule/check?actorId=${actorId}&date=${date}`)
}
export const getSlots = ({ actorId, date, serviceCategoryId }) => {
    return axios.get(`schedule/patient?actorId=${actorId}&date=${date}&serviceCategoryId=${serviceCategoryId}`)
}